import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTimes,
  faInfoCircle,
  faSpinner,
  faSave,
} from "@fortawesome/free-solid-svg-icons";

function CreateGroupModal({
  show,
  createGroupData,
  createGroupLoading,
  createGroupError,
  onSubmit,
  onCancel,
  onChange,
}) {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>
            <FontAwesomeIcon icon={faPlus} />
            Create New Group
          </h3>
          <button className="modal-close" onClick={onCancel}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <form onSubmit={onSubmit}>
          <div className="modal-body">
            {createGroupError && (
              <div className="common-message error">
                <FontAwesomeIcon icon={faInfoCircle} />
                <span>{createGroupError}</span>
              </div>
            )}

            <div className="common-form-field">
              <label htmlFor="groupName">Group Name *</label>
              <input
                type="text"
                id="groupName"
                value={createGroupData.name}
                onChange={(e) =>
                  onChange({
                    ...createGroupData,
                    name: e.target.value,
                  })
                }
                required
                placeholder="Enter group name"
                disabled={createGroupLoading}
              />
            </div>

            <div className="common-form-field">
              <label htmlFor="groupDescription">Description</label>
              <textarea
                id="groupDescription"
                value={createGroupData.description}
                onChange={(e) =>
                  onChange({
                    ...createGroupData,
                    description: e.target.value,
                  })
                }
                placeholder="Enter group description (optional)"
                rows="3"
                disabled={createGroupLoading}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="common-button secondary"
              onClick={onCancel}
              disabled={createGroupLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="common-button"
              disabled={createGroupLoading || !createGroupData.name.trim()}
            >
              {createGroupLoading ? (
                <>
                  <FontAwesomeIcon icon={faSpinner} spin />
                  Creating...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faSave} />
                  Create Group
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateGroupModal;
